import { Button } from '@/ui';
import { HolderOutlined } from '@ant-design/icons';
import { useRowContext } from '../../helpers';

const DragButton = () => {
  const { setActivatorNodeRef, listeners } = useRowContext();
  return (
    <Button
      type="text"
      size="small"
      icon={<HolderOutlined />}
      style={{ cursor: 'move' }}
      ref={setActivatorNodeRef}
      {...listeners}
    />
  );
};

export default DragButton;
